
import reducer from "./reducer";
import { createStore } from 'redux';


const initialState = {
   device: {
      mobile: true,
      size: "xs",
      type: "phone"
   },
   updatePasswordModalOpen: false,
   subscriptionFee: null,
   authenticated: false,
   dashboardRoute: null,
   businessInfo: null,
   branchEditorMode: null,
   branchBeingEditor: null,
   parentToNewBranch: null,
}

const store = createStore(
   reducer,
   initialState
);

export default store;